import {Determinant} from "./determinant";
import {TextOperatorType} from "./text-operator";

export class TextDeterminant extends Determinant {

  public textValue: string;
  public operator: TextOperatorType;

}
